// extracted by mini-css-extract-plugin
export default {"container":"emoji_container__DuMD8","small":"emoji_small__i-DnN","big":"emoji_big__n7bt3","content":"emoji_content__GZTdW"};